import CryptoJS from 'crypto-js';

export function encrypt(plainString, key) {
  const iv = CryptoJS.enc.Utf8.parse('\0'.repeat(16)); // 16-byte zero IV
  const parsedKey = CryptoJS.enc.Utf8.parse(key.padEnd(16, '\0').slice(0, 16)); // Ensure 16-byte key for AES-128

  const encrypted = CryptoJS.AES.encrypt(plainString, parsedKey, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  return encrypted.toString(); // Base64 string
}

export function encryptLeadData(leadData) {
  const stringifiedJson = JSON.stringify(leadData);
  return encrypt(stringifiedJson, "N1WpFLPGW5Ts0hla");
}
